import React from "react";
import PropTypes from "prop-types";

import "./P2PRegistrationBase.scss";

const P2PRegistrationBase = ({ children }) => (
    // During the renaming of all things event -> p2pRegistration, it was discovered that
    // there are a lot of legacy interactions with CMS that use the same class for
    // both legacy and standard forms, so we are going to keep this className the same
    <section className="event-content">{children}</section>
);
P2PRegistrationBase.propTypes = {
    children: PropTypes.node.isRequired,
};

export default P2PRegistrationBase;
